import { Component, AfterViewInit, Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { AppointmentsService } from "../service/Appointments.Service";
import { VisitHistoryDataModel, RecentAppointmentsDataModel, UserData, GeneralBookingModel } from "../../Model/index";
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { Router } from "@angular/router";
import { ModalComponent } from "../../shared/modeldialog/index";
import { BookingService } from "../../booking/service/booking.service";
declare let Checkout: any;
declare var bookingGrid: any;
declare let jspdf: any;
declare let html2canvas: any;
declare var require: any;
@Component({
  selector: 'MentisSoft-Appointments',
  template: require('../Template/Appointments.template.html'),
  styles: [require('../Template/Appointments.css')],
    providers: [AppointmentsService]
})

export class AppointmentsComponent implements AfterViewInit {
    Querynumber: string;
    doctorname: string;
  constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private _appointmentService: AppointmentsService, private _bookingService: BookingService, private cdr: ChangeDetectorRef,
    private _titleService: Title, private router: Router) {
    bookingGrid = this;
    this.Querynumber = router.parseUrl(router.url).queryParams["Id"];

    if (this.Querynumber == "" || this.Querynumber == undefined) {
      this.Querynumber = this.router.parseUrl(this.router.url).queryParams["result"];
    }
  }
  @ViewChild("viewModelPopup") viewModelPopup: ModalComponent;
  @ViewChild("sickleaveReport") sickleaveReport: ModalComponent;
  @ViewChild("orderPrintReport") orderPrintReport: ModalComponent;
  @ViewChild("payNowBookingPopup") payNowBookingPopup: ModalComponent;
  @ViewChild("BookingConfirmedPayment") BookingConfirmedPayment: ModalComponent;
  @ViewChild("PopupPayment") PopupPayment: ModalComponent;
  @ViewChild("IsPatientValid") IsPatientValid: ModalComponent;
  @ViewChild("loadingindicator") loadingindicator: ModalComponent;

  message: string;
  loading = false;
  sickLeaveReportDetails: any = {};
  orderPrintReportDetails: any = {};
  totalrecentApplength: number = 0;
  dataSource: VisitHistoryDataModel[] = [];
  dataSourceAppointments: RecentAppointmentsDataModel[] = [];
  dataSourceAppointmentsFiltered: RecentAppointmentsDataModel[] = [];
  GeneralBookSelected: GeneralBookingModel = new GeneralBookingModel();
  recentAppIndex: number = 0;
  dataSourceRequestedData: RecentAppointmentsDataModel = new RecentAppointmentsDataModel();
  columns: any[] = [];
  reportsLength: number;
  IsBookingConfirmed: boolean;
  IsAdminUser: boolean = false;
  IsPatientSearch: boolean = false;
  patientId: string = "";
  patientName: string = "";
  errMsg: string = "";

  PaymentType: string = "";
  PaylaterStatus: string = "";
  IsPopupPayment: boolean = false;
  IsPatientValidFailed: boolean = false;
  IsReschedule: string = "";

  ngAfterViewInit(): void {
    this.IsAdminUser = JSON.parse(localStorage.getItem("ISAdmin"));
    if (this.IsAdminUser == true) {
      if (localStorage.getItem("AdminPatientId") != undefined || localStorage.getItem("AdminPatientId") != null)
        this.patientId = localStorage.getItem("AdminPatientId");
      if (localStorage.getItem("AdminPatientName") != undefined || localStorage.getItem("AdminPatientName") != null)
        this.patientName = localStorage.getItem("AdminPatientName");
      if (this.patientName == "null")
        this.patientName = "";
    }
    $('#overlay').hide();
    this._titleService.setTitle("Appointment Reports");
    if (this.Querynumber != "" && this.Querynumber != undefined) {
      if (this.IsAdminUser == true) {
        this.patientId = this.Querynumber;
      }
      this.LoadingAfterPayment(this.Querynumber);
    }
    this.LoadVisitHistoryReports();
    this.LoadRecentAppointments();
  }
  PatientSearch() {
    if (this.patientId == "" || this.patientId == undefined || this.patientId == null) {
      this.IsPatientSearch = true;
      this.errMsg = "Please enter the required mandatory(*) filed.";
    }
    else {
      this.IsPatientSearch = false;
      this.LoadVisitHistoryReports();
      this.loading = true;
      this._appointmentService.getRecentAppointments(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser)
        .subscribe(
          s => {
            if (s.sessionExpiry && s.SessionTimeout != "Session Expired") {
              if (s.RecentAppointmentsList != null) {
                this.loading = false;
                this.dataSourceAppointments = s.RecentAppointmentsList;
                this.dataSourceAppointmentsFiltered = this.dataSourceAppointments.slice(this.recentAppIndex, 2);
                this.totalrecentApplength = this.dataSourceAppointments.length;
                this.PaymentType = s.PaymentType;
                this.PaylaterStatus = s.PaylaterStatus;
                this._SecurityService.errorMessage = "";
              }
            }

            else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });

    }


  }
  LoadRecentAppointments() {
    if (this.IsAdminUser == true) {
      this.loading = true;
      this._appointmentService.getRecentAppointments(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser)
        .subscribe(
          s => {
            if (s.sessionExpiry && s.SessionTimeout != "Session Expired") {
              if (s.RecentAppointmentsList != null) {
                this.loading = false;
                this.dataSourceAppointments = s.RecentAppointmentsList;
                this.dataSourceAppointmentsFiltered = this.dataSourceAppointments.slice(this.recentAppIndex, 2);
                this.totalrecentApplength = this.dataSourceAppointments.length;
                this.PaymentType = s.PaymentType;
                this.PaylaterStatus = s.PaylaterStatus;
                this.IsReschedule = s.IsReschedule;
                localStorage.setItem("IsReschedule", this.IsReschedule);
                this._SecurityService.errorMessage = "";
              }
            }

            else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });
    }
    else {
      this.loading = true;
      this._appointmentService.getRecentAppointments(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
        .subscribe(
          s => {
            if (s.sessionExpiry && s.SessionTimeout != "Session Expired") {
              if (s.RecentAppointmentsList != null) {
                this.loading = false;
                this.dataSourceAppointments = s.RecentAppointmentsList;
                this.dataSourceAppointmentsFiltered = this.dataSourceAppointments.slice(this.recentAppIndex, 2);
                this.totalrecentApplength = this.dataSourceAppointments.length;
                this.PaymentType = s.PaymentType;
                this.PaylaterStatus = s.PaylaterStatus;
                this.IsReschedule = s.IsReschedule;
                localStorage.setItem("IsReschedule", this.IsReschedule);
                this._SecurityService.errorMessage = "";
              }
            }

            else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });

    }

  }
  showCanelConfirmation(data) {
    if (this.IsAdminUser == true) {
      this._appointmentService.cancelAppointment(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, data)
        .subscribe(
          s => {
            if (s == "Success") {
              this.message = "The booked slot has been Cancelled.";
              this.viewModelPopup.open();
            } else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });
    }
    else {
      this._appointmentService.cancelAppointment(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, data)
        .subscribe(
          s => {
            if (s == "Success") {
              this.message = "The booked slot has been Cancelled.";
              this.viewModelPopup.open();
            } else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });
    }
  }

  Reschedule(data) {
    this._appointmentService.RescheduleAppointment(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, data)
      .subscribe(
        s => {
          if (s != null && s != "") {
            window.location.href = s;
          }
        },
        err => {
            this.loading = false;
            console.log("Error while getting data...");
        });
  }

  closepopup() {
    this.viewModelPopup.close();
    if (this.IsAdminUser == true) {
      this.LoadVisitHistoryReports();
      this.LoadRecentAppointments();
    }
    else {
      window.location.reload();
    }

  }

  getPrevAppointments() {
    this.recentAppIndex = this.recentAppIndex - 2;
    if (this.recentAppIndex >= 0) {
      this.dataSourceAppointmentsFiltered = this.dataSourceAppointments.slice(this.recentAppIndex, this.recentAppIndex + 2);
    }
  }
  getNextAppointments() {
    this.recentAppIndex = this.recentAppIndex + 2;
    if (this.recentAppIndex < this.dataSourceAppointments.length) {
      this.dataSourceAppointmentsFiltered = this.dataSourceAppointments.slice(this.recentAppIndex, this.recentAppIndex + 2);
    }

    if (this.dataSourceAppointments.length % 2 == 0) {
      this.reportsLength = this.dataSourceAppointments.length - 2;
    }
    else {
      this.reportsLength = this.dataSourceAppointments.length - 1;
    }

  }

  LoadVisitHistoryReports() {
    if (this.IsAdminUser == true) {
      this.loading = true;
      this._appointmentService.getAppoinmentVisitHistory(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser)
        .subscribe(
          s => {
            if (s.sessionExpiry && s.SessionTimeout != "Session Expired") {
              this.loading = false;
              this.dataSource = s.visitHistoryList;
              this.IsReschedule = localStorage.getItem("IsReschedule");
              this.buildGrid();
              this._SecurityService.errorMessage = "";
            }

            else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });
    }
    else {
      this.loading = true;
      this._appointmentService.getAppoinmentVisitHistory(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser)
        .subscribe(
          s => {
            if (s.sessionExpiry && s.SessionTimeout != "Session Expired") {
              this.loading = false;
              this.dataSource = s.visitHistoryList;
              this.IsReschedule = localStorage.getItem("IsReschedule");
              this.buildGrid();
              this._SecurityService.errorMessage = "";
            }

            else {
              this._SecurityService.errorMessage = "Your session has expired. Please login again.";
              this.router.navigate(["/Login"]);
            }
          },
          err => {
              this.loading = false;
              console.log("Error while getting data...");
          });
    }

  }

  public buildGrid() {
    try {
      this.buildColumn();

      var dgrid = jQuery("#grdVisitHistory").data("kendoGrid");
      if (dgrid) {
        $('#grdVisitHistory').data().kendoGrid.destroy();
        $('#grdVisitHistory').empty();
      }
      jQuery('#grdVisitHistory').kendoGrid({
        editable: false,
        filterable: true,
        pageable: {
          pageSizes: [5, 10, 20, 40, 80, 100]
        },
        height: 400,
        scrollable: true,
        sortable: false,
        columns: this.columns,
        filterMenuInit: function (e) {
          if (e.field != "SubmissionID" && e.field != "NameInsuredOrTreatyTitle") {
            var filterMultiCheck = e.sender.thead.find("[data-field=" + e.field + "]").data("kendoFilterMultiCheck");
            filterMultiCheck.container.empty();
            var chkSourceData = filterMultiCheck.checkSource.data();

            chkSourceData.sort(function (a: any, b: any) {
              var sortStatus = 0;

              if (a[e.field].toLowerCase() < b[e.field].toLowerCase()) {
                sortStatus = -1;
              } else if (a[e.field].toLowerCase() > b[e.field].toLowerCase()) {
                sortStatus = 1;
              }

              return sortStatus;
            });

            filterMultiCheck.checkSource.data(chkSourceData.toJSON());
            filterMultiCheck.createCheckBoxes();
          }
        },
        dataBinding: this.databinding,        
        dataSource: {
          data: this.dataSource,
          pageSize: this.dataSource != null ? 10 : 0
        },
      });
      jQuery("#grdVisitHistory").data("kendoGrid").wrapper.children(".k-grid-pager").find("span.k-input").html('All');
      var gridPage = jQuery("#grdVisitHistory").data("kendoGrid");
      gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html('10');
      var pageSizeDropDownList = gridPage.wrapper.children(".k-grid-pager").find("select").data("kendoDropDownList");
      pageSizeDropDownList.bind("change", function (e: any) {
        gridPage.wrapper.children(".k-grid-pager").find("span.k-input").html(gridPage.wrapper.children(".k-grid-pager").find("select").find('option:selected').text());
      });
    }
    catch (ex) {
      this.handleError(ex);
    }
  }

  buildColumn(): void {
    this.columns = [
      {
        field: "",
        title: " ",
        template: kendo.template("#=this.buildLabReportRow(DOCTORNAME, VISITDATE, PAYMENTTYPE, VISITTYPE, PURPOSEOFVISIT,OP_NO,SickNumber,IP_No)#").bind(this)
      }
    ];
  }

  buildLabReportRow(DOCTORNAME: string, VISITDATE: string, PAYMENTTYPE: string, VISITTYPE: string, PURPOSEOFVISIT: string, OP_NO, SickNumber, IP_No): string {
    var line1 = "<div class='resultstablewrap ptb4 plr0'><div class='visit_wrap'><div class='doctor_date'>";
    var line2 = "<span><i class='fa fa-calendar-check-o' aria- hidden='true'> </i> " + VISITDATE + "</span><span class='pull-right'>";
    var line3 = "<strong>Dr.</strong>" + DOCTORNAME + " </span> </div>";
    bookingGrid.doctorname = DOCTORNAME;
    if (PURPOSEOFVISIT != null && PURPOSEOFVISIT != "") {
      var line4 = "<div class='resson_visit'><span><strong>Reason:</strong> " + PURPOSEOFVISIT + " </span>";
      return line1 + line2 + line3 + line4;
    }
    else if (SickNumber != null && SickNumber != "" && this.IsReschedule === "TRUE" ) {
        var line2 = "<span><i class='fa fa-calendar-check-o' aria- hidden='true'> </i> " + VISITDATE + "</span><span class='text-center green-bg downloadbtn sickleavereport' onclick = bookingGrid.downloadReport('" + OP_NO + "','" + SickNumber + "','" + IP_No + "') > <i class='fa fa-download' aria- hidden='true' > </i>  Sick Leave <i class='fa fa-file-text' aria- hidden='true'> </i> </span> <span class='text-center green-bg downloadbtn sickleavereport' onclick = bookingGrid.downloadOrderPrintReport('" + OP_NO + "','" + IP_No + "') > <i class='fa fa-download' aria- hidden='true' > </i> Order Print <i class='fa fa-file-text' aria- hidden='true'> </i> </span> <span class='pull-right'> ";
        return line1 + line2 + line3 ;
    }
    else if (SickNumber === "" && OP_NO != null && OP_NO != "" && this.IsReschedule === "TRUE" || SickNumber === "" && IP_No != null && IP_No != "" && this.IsReschedule === "TRUE") {
        var line2 = "<span><i class='fa fa-calendar-check-o' aria- hidden='true'> </i> " + VISITDATE + "</span><span class='text-center green-bg downloadbtn sickleavereport' onclick=bookingGrid.downloadOrderPrintReport('" + OP_NO + "','" + IP_No + "')><i class='fa fa-download' aria- hidden='true'> </i> Order Print <i class='fa fa-file-text' aria- hidden='true'> </i> </span> <span class='pull-right'>";
        return line1 + line2 + line3;
    }
   
    
    else {
      return line1 + line2 + line3;
    }
  }


  orderPrint() {
      this.orderPrintReport.open();
  }


  makeOrderPrintPdf(): void {
      const div = document.getElementById("Html2Pdf1");
      const options = { height: div.clientHeight, width: div.clientWidth };
      html2canvas(div, options).then((canvas) => {
          const doc = new jspdf.jsPDF("p", "mm", "a4");
          var imgData = canvas.toDataURL('image/JPEG');
          /*Here are the numbers (paper width and height) that I found to work. It still creates a little overlap part between the pages, but good enough for me.if you can find an official number from jsPDF, use them. */
          var imgWidth = 210;
          var pageHeight = 295;
          var imgHeight = canvas.height * imgWidth / canvas.width;
          var heightLeft = imgHeight;
          var position = 0;

          doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft >= 0) {
              position = heightLeft - imgHeight;
              doc.addPage();
              doc.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
              heightLeft -= pageHeight;
          }
          const fileName = "OrderPrintReport.pdf";
          doc.save(fileName);

      });

  }
  downloadReport(opNumber, sicknumber,ipnumber) :void{
      this.getReport(opNumber, sicknumber,ipnumber);
  }

  downloadOrderPrintReport(opNumber, ipNumber): void {
      this.getOrderPrintReport(opNumber, ipNumber);
  }

  makePdf():void {
    const div = document.getElementById("Html2Pdf");
    const options = { height: div.clientHeight, width: div.clientWidth };
    html2canvas(div, options).then((canvas) => {
      const doc = new jspdf.jsPDF("p", "mm", "a4");
      var width = doc.internal.pageSize.getWidth();
      var height = doc.internal.pageSize.getHeight();
      const imgData = canvas.toDataURL("image/JPEG");
     if (window.innerWidth > 900)
     {
     doc.addImage(imgData, 'JPEG', 20, 20);
     }
    else
     {
      doc.addImage(imgData, 'JPEG', 5, 5,width,height);
     }
      const fileName = "SickLeaveReport.pdf";
      doc.save(fileName);
    });
  }

 getReport(opNumber, sicknumber,ipnumber):void {
    this._appointmentService.getSickLeaveReport(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, opNumber, sicknumber,ipnumber)
      .subscribe(
        s => {
            if (s.sessionExpiry) {
            setTimeout(() => {
           
            this.sickLeaveReportDetails = s.SickLeaveReportyList[0];
            if(this.sickLeaveReportDetails && this.sickLeaveReportDetails.SEX && this.sickLeaveReportDetails.SEX ==='M')
            {
              this.sickLeaveReportDetails.SEX = 'Male'
            }
            else
            {
              this.sickLeaveReportDetails.SEX = 'Female'
            }
            if(this.sickLeaveReportDetails && this.sickLeaveReportDetails.DATEC)
            {
             const Datetime = this.sickLeaveReportDetails.DATEC.split(' ')
             this.sickLeaveReportDetails.date=Datetime[0];
             this.sickLeaveReportDetails.time=Datetime[1] +' ' +  Datetime[2];
            }
           
            this.cdr.detectChanges();
            bookingGrid.sickleaveReport.open();
           

                }, 500);
            }
            else if (!s.SessionExpiry) {
                this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                this.router.navigate(["/Login"]);
            }
        },
        err => {
            this.loading = false;
            console.log("Error while getting data...");
        });
  }


 getOrderPrintReport(opNumber, ipnumber): void {
     this.loadingindicator.open();
    
     this._appointmentService.getOrderPrintReport(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, opNumber, ipnumber)
         .subscribe(
         s => {
             if (s.SessionExpire) {
             setTimeout(() => {
                 this.orderPrintReportDetails = s;
                 window.document.getElementById("closeBtn").click();
                 this.orderPrintReportDetails.DoctorName = this.doctorname;
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.LabDataDetails.length != 0 && this.orderPrintReportDetails.LabDataDetails.length != 0) {

                     this.orderPrintReportDetails.LabDataDetails = s.LabDataDetails.concat(s.RadiologyDataDetails);
                 }
                 
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.LabDataDetails.length != 0) {
                    
                     this.orderPrintReportDetails.DoctorName = s.LabDataDetails[0].DoctorName;
                 }
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.PrescriptionsReports.length != 0) {

                     this.orderPrintReportDetails.DoctorName = s.PrescriptionsReports[0].EnteredBy;
                 }
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.Gender && this.sickLeaveReportDetails.Gender === 'M') {
                     this.orderPrintReportDetails.Gender = 'Male'
                 }
                 else {
                     this.orderPrintReportDetails.Gender = 'Female'
                 }
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.DateOfBirth) {
                     const Datetime = this.orderPrintReportDetails.DateOfBirth.split(' ')
                     this.orderPrintReportDetails.DateOfBirth = Datetime[0];
                    
                 }
                 if (this.orderPrintReportDetails && this.orderPrintReportDetails.Date) {
                     const currentDate = new Date()
                     const day = currentDate.getDate()
                     const month = currentDate.getMonth() + 1
                     const year = currentDate.getFullYear();
                     this.orderPrintReportDetails.Date = day + "/" + month + "/" + year;
                 }
                 this.cdr.detectChanges();
                 bookingGrid.orderPrintReport.open();
                 }, 500);
             }
             else if (!s.SessionExpire) {
                 this._SecurityService.errorMessage = "Your session has expired. Please login again.";
                 this.router.navigate(["/Login"]);
             }
         },
         err => {
             this.loading = false;
             console.log("Error while getting data...");
         });
 }
  databinding(e: any) {
    try {
      var grid = jQuery("#grdVisitHistory").data("kendoGrid");
      var totalCount = grid.dataSource.total();
      var pageSizes = [{ text: "10", value: 10 }, { text: "25", value: 25 }, { text: "50", value: 50 }, { text: "100", value: 100 }, { text: "All", value: totalCount }];
      var pagerdropdownBox = jQuery('.k-pager-sizes select[data-role="dropdownlist"]').data('kendoDropDownList');
      var pagerds = new kendo.data.DataSource({
        data: pageSizes
      });
      pagerdropdownBox.setDataSource(pagerds);
    }
    catch (e) {
    }
  }

    private handleError(error: any) {
        console.log("error : " + error);
  }

  PayNowAppointmentRequest(data) {
    this.dataSourceRequestedData = data;

    if (this.IsAdminUser == true) {
      this.loading = true;
      this.GeneralBookSelected.consultationFee = this.dataSourceRequestedData.ConsultationFees;
      this.GeneralBookSelected.Id = this.patientId;
      if ((this.PaymentType != "Y") || (this.PaymentType == "Y" && this.GeneralBookSelected.PaymentTypeMode == "BENEFIT")) {
        this._appointmentService.PayNowAppointmentRequest(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser, this.dataSourceRequestedData)
          .subscribe(
            s => {
              if (s != null && s != "") {
                window.location.href = s;
              }
            },
            err => {
                this.loading = false;
                console.log("Error while getting data...");
            });
      }
      else {
        if (this.GeneralBookSelected.consultationFee != "0" && this.GeneralBookSelected.consultationFee != "0.00" && this.GeneralBookSelected.consultationFee != undefined && this.GeneralBookSelected.consultationFee != "") {
         
          var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this.patientId, this._SecurityService.IsAdminUser);

          this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
            .subscribe(
              p => {
                this.loading = false;
                if (p.length != 0) {
                  this.dataSourceRequestedData.credimaxPaymentDetails = p.credimaxPaymentDetails;
                }
                else {

                }
              },
              err => {
                  this.loading = false;
                  console.log("Error while getting department data...");
              });
          this.IsPopupPayment = true;
          this.PopupPayment.open();
        }
        else {
          this.IsPatientValidFailed = true;
          this.IsPatientValid.open();
          this.message = "consultation Fee should be greater than zero.";
        }
      }
    }
    else {
      this.loading = true;
      this.GeneralBookSelected.consultationFee = this.dataSourceRequestedData.ConsultationFees;
      this.GeneralBookSelected.Id = this._SecurityService.pid;
      if ((this.PaymentType != "Y") || (this.PaymentType == "Y" && this.GeneralBookSelected.PaymentTypeMode == "BENEFIT")) {
        this._appointmentService.PayNowAppointmentRequest(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser, this.dataSourceRequestedData)
          .subscribe(
            s => {
              if (s != null && s != "") {
                window.location.href = s;
              }
            },
            err => {
                this.loading = false;
                console.log("Error while getting data...");
            });
      }
      else {
        if (this.GeneralBookSelected.consultationFee != "0" && this.GeneralBookSelected.consultationFee != "0.00" && this.GeneralBookSelected.consultationFee != undefined && this.GeneralBookSelected.consultationFee != "") {

          var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

          this._bookingService.PaymentModeSelectionGuest(data, userData)
            .subscribe(
              p => {
                this.loading = false;
                if (p.length != 0) {
                  this.dataSourceRequestedData.credimaxPaymentDetails = p.credimaxPaymentDetails;
                }
                else {

                }
              },
              err => {
                  this.loading = false;
                  console.log("Error while getting department data...");

              });
          this.IsPopupPayment = true;
          this.PopupPayment.open();
        }
        else {
          this.IsPatientValidFailed = true;
          this.IsPatientValid.open();
          this.message = "consultation Fee should be greater than zero.";
        }
      }
    }

  }

  LoadingAfterPayment(Querynumber: string) {
    var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
    this._appointmentService.AfterPaymentConfirmation(Querynumber, userData)
      .subscribe(
        s => {
          if (s != null && s.isValid) {
            this.IsBookingConfirmed = true;
            this.payNowBookingPopup.open();
          }
          else {
            this.IsBookingConfirmed = false;
            this.payNowBookingPopup.open();
          }

        },
        err => {
            console.log("Error while getting data...");
        });
  }

  payNowclosepopup() {
    this.payNowBookingPopup.close();
    this.LoadRecentAppointments();
  }

  PaymentPopupProceed(radioPayment) {
    if (radioPayment != undefined) {
      if (radioPayment == 0) {
        this.GeneralBookSelected.PaymentTypeMode = "CREDIMAX";
        this.dataSourceRequestedData.PaymentTypeMode = "CREDIMAX";
        this.payCredimaxWithCreditCard();
      }
      else {
        this.GeneralBookSelected.PaymentTypeMode = "BENEFIT";
        this.dataSourceRequestedData.PaymentTypeMode = "BENEFIT";
      }
    }
    this.GeneralBookSelected.buttonActivity = "Payment";
    this.PayNowAppointmentRequest(this.dataSourceRequestedData);
    this.PopupPayment.close();
    this.IsPopupPayment = false;
  }

  OnChangeCredit(radioPayment) {
    if (radioPayment != undefined) {
      if (radioPayment == 0) {
        this.GeneralBookSelected.PaymentTypeMode = "CREDIMAX";
        var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);

        this._bookingService.PaymentModeSelectionGuest(this.GeneralBookSelected, userData)
          .subscribe(
            p => {
              this.loading = false;
              if (p.length != 0) {
                this.GeneralBookSelected.credimaxPaymentDetails = p.credimaxPaymentDetails;
              }
              else {

              }
            },
            err => {
                this.loading = false;
                console.log("Error while getting department data...");
            });
      }
      else {
        this.GeneralBookSelected.PaymentTypeMode = "BENEFIT";
      }
    }
  }
  payCredimaxWithCreditCard() {
    Checkout.configure({
      merchant: this.GeneralBookSelected.credimaxPaymentDetails[0].merchantId,
      order: {
        amount: this.GeneralBookSelected.credimaxPaymentDetails[0].amount,
        currency: this.GeneralBookSelected.credimaxPaymentDetails[0].currency,
        description: this.GeneralBookSelected.credimaxPaymentDetails[0].description,
        id: this.GeneralBookSelected.credimaxPaymentDetails[0].orderId
      },
      session: {
        id: this.GeneralBookSelected.credimaxPaymentDetails[0].sessionId
      },
      interaction: {
        merchant: {
          name: this.GeneralBookSelected.credimaxPaymentDetails[0].name,
          address: {
            line1: 'Manama',
            line2: 'Manama'
          }
        }
      }
    });
    Checkout.showPaymentPage();
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Appointments/Component/Appointments.Component.ts